// extracted by mini-css-extract-plugin
module.exports = {"FTG":"chart_FTG__2rm2I","container":"chart_container__6PU8O"};